
import { BaseService } from "core/services";
import { PickTicketHeaderRouteService } from "application/pick-ticket/services";

class PickTicketHeaderService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PickTicketHeaderRouteService());
	}

	createPickTicket(facilityOrderId) {
		const url = this.routeService.createPickTicket(facilityOrderId);

		return this.apiClient.post(url);
	}

	getPickTicketReportDownloadUrl(id) {
		return this.apiClient.appOptions.apiUrl + this.routeService.pickTicketReportDownloadUrl(id);
	}

	async setStatus(resource) {
        const url = this.routeService.setStatus(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async refresh(id){
        const url = this.routeService.refresh(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }

	async createPickTicketNewFlow(resource) {
		const url = this.routeService.createPickTicketNewFlow();
		return this.apiClient.post(url, resource);
	}

	async refreshNewFlow(id){
        const url = this.routeService.refreshNewFlow(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }

	getPickTicketReportDownloadUrlNewFlow(id) {
		return this.apiClient.appOptions.apiUrl + this.routeService.pickTicketReportDownloadUrlNewFlow(id);
	}

	getPickDeliveryReportDownloadUrlNewFlow(id){
		return this.apiClient.appOptions.apiUrl + this.routeService.pickDeliveryReportDownloadUrlNewFlow(id);
	}

	getDeliveryReportDownloadUrlNiko(id) {
		return this.apiClient.appOptions.apiUrl + this.routeService.deliveryReportDownloadUrlNiko(id);
	}

	pickTicketReportOrderSummaryDownloadUrlNewFlow(id) {
		return this.apiClient.appOptions.apiUrl + this.routeService.pickTicketReportOrderSummaryDownloadUrlNewFlow(id);
	}

	pickTicketReportDownloadUrlNiko(id) {
		return this.apiClient.appOptions.apiUrl + this.routeService.pickTicketReportDownloadUrlNiko(id);
	}

	async getExcludedAndIncludedFacilityOrderTemplateItems(facilityOrderId) {
        const url = this.routeService.getExcludedAndIncludedFacilityOrderTemplateItems(facilityOrderId);
        return await this.apiClient.get(url);
    }

	async getSentSeparatelyFacilityOrderTemplateItems(facilityOrderId) {
        const url = this.routeService.getSentSeparatelyFacilityOrderTemplateItems(facilityOrderId);
        return await this.apiClient.get(url);
    }	

	sendInfoEmail(facilityOrderId) {
		const url = this.routeService.sendInfoEmail(facilityOrderId);
		return this.apiClient.post(url);
	}

	async sendAgoraPo(id) {
        const url = this.routeService.sendAgoraPo(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }

	getAgoraPoReportDownloadUrl(id) {
		return this.apiClient.appOptions.apiUrl + this.routeService.agoraPoReportDownloadUrl(id);
	}

	getAgoraPoReportDownloadUrlNiko(id) {
		return this.apiClient.appOptions.apiUrl + this.routeService.agoraPoReportDownloadUrlNiko(id);
	}

	async sendAgoraPoNiko(id) {
		const url = this.routeService.sendAgoraPoNiko(id);
		const response = await this.apiClient.get(url);
		return response.data;
	}

	async hasPickTicketItemsNiko(facilityOrderId, documentName) {
		const url = this.routeService.hasPickTicketItemsNiko(facilityOrderId, documentName);
		const response = await this.apiClient.get(url);
		return response.data;
	}

	async sendOrderOrderSummary(resource) {
        const url = this.routeService.sendOrderOrderSummary(resource);
        return await this.apiClient.put(url, resource);
    }
}

export default PickTicketHeaderService;